export const STANDARD_FEC_JOURNAL_LABELS: Record<string, readonly string[]> = {
  AC: ['Purchases', 'Achats'],
  AN: ['Opening balances', 'A-nouveaux', 'À-nouveaux'],
  BQ: ['Bank', 'Banque'],
  CA: ['Cash Register', 'Caisse'],
  OD: ['Miscellaneous operations', 'Opérations diverses'],
  VT: ['Sales', 'Ventes'],
}

export const STANDARD_FEC_JOURNAL_CODES = new Set(Object.keys(STANDARD_FEC_JOURNAL_LABELS))
